<template>
  <el-dialog
    title="开通支付"
    :visible.sync="visible"
    width="720px"
    append-to-body
    :close-on-press-escape="false"
    @closed="handleClose">
    <el-form
      ref="ruleForm"
      style="padding: 0 100px;"
      :model="wxApp"
      :rules="rules"
      label-width="110px">
      <el-form-item
        label="商户ID："
        prop="wxMchid">
        <el-input v-model="wxApp.wxMchid"></el-input>
      </el-form-item>
      <el-form-item
        label="API密钥："
        prop="wxMchkey">
        <el-input v-model="wxApp.wxMchkey"></el-input>
      </el-form-item>
      <el-form-item
        label="API证书文件："
        prop="wxpayApiClientCert">
        <upload-with-file
          v-model="wxApp.wxpayApiClientCert"
          accept=".p12" />
      </el-form-item>
      <el-form-item label="">
        <el-tag type="warning">说明: 从微信商户后台下载API证书文件，并上传其中的".p12"后缀的文件</el-tag>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import UploadWithFile from '@/components/wx/upload-with-file'
export default {
  name: 'WxPayApplyModal',
  components: { UploadWithFile },
  props: {
    applyInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      wxApp: {
        wxMchid: '',
        wxMchkey: '',
        wxpayApiClientCert: []
      },
      rules: {
        wxMchid: [
          { required: true, message: '请输入AppID', trigger: 'blur' }
        ],
        wxMchkey: [
          { required: true, message: '请输入AppSecret', trigger: 'blur' }
        ],
        wxpayApiClientCert: [
          { required: true, message: '请上传证书文件', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  watch: {
    applyInfo: {
      handler(val) {
        console.log(val)
        this.wxApp.wxMchid = val.wxMchid
        this.wxApp.wxMchkey = val.wxMchkey
        this.wxApp.wxpayApiClientCert = val.wxpayApiClientCert ? [{ url: val.wxpayApiClientCert, name: val.wxpayApiClientCert.split('/')[val.wxpayApiClientCert.split('/').length - 1] }] : []
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      // this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          console.log({
            vendorId: this.applyInfo.vendorId,
            ...this.wxApp,
            wxpayApiClientCert: this.wxApp.wxpayApiClientCert.map(i => i.url).join(',')
          })
          this.$store.dispatch('wxaccount/updatevendor', {
            payload: {
              vendorId: this.applyInfo.vendorId,
              ...this.wxApp,
              wxpayApiClientCert: this.wxApp.wxpayApiClientCert.map(i => i.url).join(',')
            },
            success: () => {
              this.loading = false
              this.$store.dispatch('wxaccount/updateUserDetail', {
                payload: {
                  vendorId: this.applyInfo.vendorId
                }
              })
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
